import { btnBlackStyle, btnOutlineStyle, cardStyle } from "../styles/adminDashboardStyles";
import { DELIVERY_CALENDAR_THEME } from "./deliveryCalendar";

const ellipsisStyle = { display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };

export const deliveryCalendarCardStyle = {
    ...cardStyle,
    padding: 0,
    overflow: "hidden",
    border: `1px solid ${DELIVERY_CALENDAR_THEME.border}`,
    borderRadius: "16px",
    background: "#fff",
    boxShadow: "0 1px 2px rgba(12,59,60,.04)",
};

export const deliveryCalendarTitleStyle = { margin: 0, color: DELIVERY_CALENDAR_THEME.ink, fontFamily: "Georgia, serif", fontSize: "26px", fontWeight: 700, letterSpacing: "-0.3px" };

export const deliveryCalendarCountStyle = { fontSize: "12px", fontWeight: 800, color: DELIVERY_CALENDAR_THEME.petrol, background: DELIVERY_CALENDAR_THEME.petrolTint, padding: "4px 10px", borderRadius: "999px" };

export const deliveryCalendarViewGroupStyle = { display: "inline-flex", background: DELIVERY_CALENDAR_THEME.petrolTint, borderRadius: "10px", padding: "4px", gap: "4px" };

export function deliveryCalendarViewButtonStyle(active) {
    return {
        height: "34px",
        padding: "0 16px",
        border: "none",
        borderRadius: "7px",
        background: active ? "#fff" : "transparent",
        color: active ? DELIVERY_CALENDAR_THEME.petrol : DELIVERY_CALENDAR_THEME.gray,
        boxShadow: active ? "0 1px 2px rgba(12,59,60,.1)" : "none",
        fontSize: "13px",
        fontWeight: 700,
        cursor: "pointer",
    };
}

export const deliveryAddButtonStyle = { ...btnBlackStyle, height: "42px", background: DELIVERY_CALENDAR_THEME.petrol, borderRadius: "10px" };

export const deliveryNavigationStyle = { display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px", padding: "16px 28px", borderTop: `1px solid ${DELIVERY_CALENDAR_THEME.border}`, flexWrap: "wrap" };

export const deliveryNavigationButtonStyle = { ...btnOutlineStyle, height: "42px", borderRadius: "10px", border: `1px solid ${DELIVERY_CALENDAR_THEME.border}`, color: DELIVERY_CALENDAR_THEME.ink };

export const deliveryWeekDaysStyle = { display: "grid", gridTemplateColumns: "repeat(7, minmax(0, 1fr))", background: DELIVERY_CALENDAR_THEME.petrolTint, borderBottom: `2px solid ${DELIVERY_CALENDAR_THEME.validation}` };

export const deliveryWeekDayStyle = { minWidth: 0, padding: "13px 16px", color: DELIVERY_CALENDAR_THEME.gray, fontSize: "12px", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.04em" };

export function deliveryDayStyle(day, calendarView, canAddOnDay) {
    return {
        minWidth: 0,
        minHeight: calendarView === "week" ? "320px" : "132px",
        padding: "10px",
        borderRight: day.date.getDay() === 0 ? "none" : `1px solid ${DELIVERY_CALENDAR_THEME.border}`,
        borderBottom: `1px solid ${DELIVERY_CALENDAR_THEME.border}`,
        background: canAddOnDay ? "#fff" : DELIVERY_CALENDAR_THEME.cream,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    };
}

function dayNumberColor(isToday, canAddOnDay) {
    if (isToday) return "#fff";
    return canAddOnDay ? DELIVERY_CALENDAR_THEME.ink : "#b9c2bf";
}

export function deliveryDayNumberStyle(isToday, canAddOnDay) {
    return {
        border: "none",
        background: isToday ? DELIVERY_CALENDAR_THEME.petrol : "transparent",
        color: dayNumberColor(isToday, canAddOnDay),
        borderRadius: "50%",
        width: isToday ? "26px" : "auto",
        height: "26px",
        minWidth: "26px",
        cursor: canAddOnDay ? "pointer" : "default",
        fontSize: "14px",
        fontWeight: 800,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isToday ? 0 : "0 4px",
    };
}

export const deliveryDayCountStyle = { color: DELIVERY_CALENDAR_THEME.petrol, background: DELIVERY_CALENDAR_THEME.petrolTint, padding: "2px 7px", borderRadius: "999px", fontSize: "11px", fontWeight: 800 };

export function deliveryOccurrenceStyle(moving) {
    return {
        border: "none",
        borderLeft: `3px solid ${DELIVERY_CALENDAR_THEME.petrol}`,
        background: moving ? "#dde6e4" : DELIVERY_CALENDAR_THEME.petrolTint,
        color: DELIVERY_CALENDAR_THEME.ink,
        borderRadius: "8px",
        padding: "6px 9px",
        textAlign: "left",
        cursor: "pointer",
        width: "100%",
        minWidth: 0,
        minHeight: "44px",
        boxSizing: "border-box",
        opacity: moving ? 0.62 : 1,
    };
}

export const deliveryOccurrenceTimeStyle = { ...ellipsisStyle, color: DELIVERY_CALENDAR_THEME.petrol, fontSize: "11px", fontWeight: 800 };
export const deliveryOccurrenceLabelStyle = { ...ellipsisStyle, color: DELIVERY_CALENDAR_THEME.ink, fontSize: "12.5px", fontWeight: 800, marginTop: "1px" };
export const deliveryOccurrenceTargetsStyle = { ...ellipsisStyle, color: DELIVERY_CALENDAR_THEME.gray, fontSize: "11px" };
export const deliveryOccurrenceDriverStyle = { ...ellipsisStyle, fontSize: "10px", color: DELIVERY_CALENDAR_THEME.gray, marginTop: "2px" };
export const deliveryOccurrenceCadenceStyle = { ...ellipsisStyle, color: DELIVERY_CALENDAR_THEME.validationDeep, fontSize: "11px", fontWeight: 700, marginTop: "1px" };
export const deliveryOccurrenceMovedStyle = { ...ellipsisStyle, fontSize: "10px", color: DELIVERY_CALENDAR_THEME.alert, marginTop: "2px" };

export function deliveryEmptyDayButtonStyle(calendarView) {
    return {
        border: `1.5px dashed ${DELIVERY_CALENDAR_THEME.border}`,
        background: "transparent",
        color: DELIVERY_CALENDAR_THEME.gray,
        borderRadius: "10px",
        minHeight: calendarView === "week" ? "180px" : "56px",
        padding: "12px",
        cursor: "pointer",
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        flex: 1,
        fontSize: "18px",
        fontWeight: 800,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };
}
